{
  "RESET_PASSWORD": {
    "TITLE": "אפס את הסיסמה",
    "DESCRIPTION": "הזן את כתובת הדוא\"ל שבה אתה משתמש כדי להיכנס ל-Chatwoot לקבלת הוראות לאיפוס הסיסמה.",
    "GO_BACK_TO_LOGIN": "אם ברצונך לחזור לדף ההתחברות,",
    "EMAIL": {
      "LABEL": "אימייל",
      "PLACEHOLDER": "הזן בבקשה את האימייל שלך.",
      "ERROR": "אנא הכנס כתובת דוא\"ל חוקית."
    },
    "API": {
      "SUCCESS_MESSAGE": "הקישור לאיפוס הסיסמה נשלח לדוא\"ל שלך.",
      "ERROR_MESSAGE": "לא ניתן להתחבר לשרת Woot, נסה שוב מאוחר יותר"
    },
    "SUBMIT": "שלח"
  }
}
